<template>
  <va-card class="container" style="overflow-x: auto; overflow-y: visible;">
    <p class="display-5" style="color: #5f6e78;">{{ title }}</p>
    <div class="body">
      <div class="inputSection">
        <label class="flex xs12 form-label">{{ this.selectedEntity.entity_name }}</label>
      </div>



      <div class="inputSection">
        <label class="flex xs12 form-label">Report Name</label>
        <va-input class="flex xs12 mb-4 form-input" v-bind:class="{ hasError: reportNameError !== '' }"
          v-model="reportName" placeholder="Enter Report Name Here" />
        <label v-if="reportNameError !== ''" class="error-label">{{ reportNameError }}</label>
      </div>


      <div class="inputSection">
        <label class="flex xs12 form-label">Export Report Name</label>
        <va-input class="flex xs12 mb-4 form-input" v-bind:class="{ hasError: name !== '' }" v-model="name"
          placeholder="Enter Export Name Here" />
        <label v-if="nameError !== ''" class="error-label">{{ nameError }}</label>
      </div>

      <div class="inputSection">
        <label class="flex xs12 form-label">Permission Code Name</label>
        <va-input class="flex xs12 mb-4 form-input" v-bind:class="{ hasError: permissionCodeNameError !== '' }"
          v-model="permissionCodeName" placeholder="Enter Permission Code Name Here" />
        <label v-if="permissionCodeNameError !== ''" class="error-label">{{ permissionCodeNameError }}</label>
      </div>

      <div class="inputSection">
        <label class="flex xs12 form-label">Work Space Id</label>
        <va-input class="flex xs12 mb-4 form-input" v-bind:class="{ hasError: workspaceIdError !== '' }"
          v-model="workspaceId" placeholder="Enter Work Space Id Here" />
        <label v-if="workspaceIdError !== ''" class="error-label">{{ workspaceIdError }}</label>
      </div>

      <div class="inputSection">
        <label class="flex xs12 form-label">Report Id</label>
        <va-input class="flex xs12 mb-4 form-input" v-bind:class="{ hasError: reportIdError !== '' }" v-model="reportId"
          placeholder="Enter Report Id Here" />
        <label v-if="reportIdError !== ''" class="error-label">{{ reportIdError }}</label>
      </div>

      <div class="buttonContainer">
        <va-button class="btn alignleft" color="gray"  @click="cancel">Cancel</va-button>
        <va-button class="btn alignright" color="gray"  @click="save">Save</va-button>
      </div>
    </div>
  </va-card>
</template>
  
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "edit-export-report-modal",
  props: {
    title: String
  },
  data() {
    return {
      name: 'Export Student Report',
      nameError: '',
      permissionCodeName: 'export_student_report',
      permissionCodeNameError: '',
      isActive: true,
      workspaceId: '',
      workspaceIdError: '',
      reportId: '',
      reportIdError: '',
      reportName: 'Student Report',
      reportNameError: ''
    }
  },
  computed: {
    ...mapState({
      selectedEntity: state => state.user.selectedEntity
    })
  },
  methods: {
    ...mapActions({
      createExportReport: "powerbiExport/createExportReport"
    }),
    cancel() {
      this.$emit("close");
    },
    save() {
      if (this.validateInput()) {
        const param = {
          entity_id: this.selectedEntity.id,
          name: this.name,
          permission_code_name: this.permissionCodeName,
          is_active: true,
          workspace_id: this.workspaceId,
          report_id: this.reportId,
          report_name: this.reportName
        };
        this.createExportReport(param).then().finally(() => { this.$emit("close"); })
      }
    },
    validateInput() {
      let isValid = true
      if (this.name === '') {
        this.nameError = 'Required';
        isValid = false;
      }
      if (this.reportName === null) {
        this.reportNameError = 'Required';
        isValid = false;
      }
      if (this.name === null) {
        this.nameError = 'Required';
        isValid = false;
      }
      if (this.permissionCodeName === null) {
        this.permissionCodeNameError = 'Required';
        isValid = false;
      }
      if (this.workspaceId === null) {
        this.workspaceIdError = 'Required';
        isValid = false;
      }
      if (this.reportId === null) {
        this.reportIdError = 'Required';
        isValid = false;
      }
      return isValid;
    }
  }
}
</script>
  
<style lang='scss' scoped>
.container {
  box-shadow: none !important;
  background: white !important;
  color: black !important;

  & .body {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;

    & .inputSection {
      //display: contents;

      & .readonly-input {
        padding-left: 0.75rem;
      }

      & .form-label {
        font-weight: 400;
        display: block;
        padding: 0.25rem;
      }

      & .form-input {
        border: 1px solid rgba(60, 60, 60, 0.26);
        border-radius: 4px;
        height: 1.5rem;
        max-height: 2rem;
        width: 100%;
        color: #333333;

        &.hasError {
          border-color: #d43d27;
        }
      }

      &+.inputSection {
        margin-top: 0.75rem;
      }

      & .error-label {
        font-size: 0.75rem;
        color: #d43d27;
        font-weight: bold;
        margin-left: 0.25rem;
      }
    }

    & .buttonContainer {
      margin-top: 0.75rem;
    }
  }
}

.alignright {
  float: right;
}

.alignleft {
  float: left;
}
</style>
  
<style lang="scss">
.va-select.hasError {
  &>.vs__dropdown-toggle {
    border-color: #d43d27;
  }
}

.va-input__content-wrapper .va-input__content__input {
  color: white !important;
}
</style>